var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "de-auto-login",
    },
    [
      _vm.isDingTalkLink && _vm.dingtalkOpen && _vm.corpId
        ? _c("plugin-com", {
            ref: "DTWithoutLogin",
            attrs: {
              "corp-id": _vm.corpId,
              "component-name": "DTWithoutLogin",
            },
          })
        : _vm.isLarkLink && _vm.larkOpen && _vm.appId
        ? _c("plugin-com", {
            ref: "LKWithoutLogin",
            attrs: { "app-id": _vm.appId, "component-name": "LKWithoutLogin" },
          })
        : _vm.isLarksuiteLink && _vm.larksuiteOpen
        ? _c("plugin-com", {
            ref: "LKSWithoutLogin",
            attrs: { "component-name": "LKSWithoutLogin" },
          })
        : _vm.isWecomLink && _vm.wecomOpen
        ? _c("plugin-com", {
            ref: "WecomWithoutLogin",
            attrs: {
              "app-id": _vm.appId,
              "agent-id": _vm.agentId,
              "redirect-uri": _vm.redirectUri,
              "component-name": "WecomWithoutLogin",
            },
          })
        : _vm._e(),
      _vm.isDingTalkLink && !_vm.loading && !_vm.dingtalkOpen
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("未开启钉钉")]),
          ])
        : _vm.isDingTalkLink && !_vm.loading && !_vm.corpId
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("缺失企业ID参数")]),
          ])
        : _vm._e(),
      _vm.isLarkLink && !_vm.loading && !_vm.larkOpen
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("未开启飞书")]),
          ])
        : _vm.isLarkLink && !_vm.loading && !_vm.appId
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("缺失应用ID参数")]),
          ])
        : _vm._e(),
      _vm.isLarksuiteLink && !_vm.loading && !_vm.larksuiteOpen
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("未开启国际飞书")]),
          ])
        : _vm._e(),
      _vm.isWecomLink && !_vm.loading && !_vm.wecomOpen
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("未开启企业微信")]),
          ])
        : _vm._e(),
      _vm.isWecomLink && !_vm.loading && !_vm.appId
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("缺失企业ID")]),
          ])
        : _vm._e(),
      _vm.isWecomLink && !_vm.loading && !_vm.agentId
        ? _c("div", { staticClass: "auto-login-missing" }, [
            _c("span", [_vm._v("缺失应用ID")]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }